'use client';

import type { LinkProps } from 'next/link';
import { Link } from 'src/navigation';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import type { ReactNode, HTMLAttributeAnchorTarget, Ref } from 'react';

export const GTMLink = ({
	href,
	ref,
	Content_Type,
	Content_Name,
	Content_Block,
	event = 'select_content',
	Object_ID,
	Button_Clicked,
	onClick,
	children,
	...restProps
}: Props) => {
	if (!href) {
		console.error('Link missing an href');
		return null;
	}

	const handleClick = (evt) => {
		if (Content_Type && Content_Name && Content_Block) {
			pushToDataLayer({
				event: event,
				Content_Type: Content_Type,
				Content_Name: Content_Name,
				Content_Block: Content_Block,
				...(Button_Clicked ? { Button_Clicked: Button_Clicked } : {}),
				...(Object_ID ? { Object_ID: Object_ID } : {}),
			});
		}

		onClick?.(evt);
	};

	return (
		<Link href={href} ref={ref} {...restProps} onClick={handleClick}>
			{children}
		</Link>
	);
};

export interface GTMLinkAnalyticsProps {
	Button_Clicked?: string;
	Content_Type?: string;
	Content_Name?: string;
	Content_Block?: string;
	event?: string;
	Object_ID?: string;
}

export interface Props extends LinkProps, GTMLinkAnalyticsProps {
	ref?: Ref<HTMLAnchorElement>;
	title?: string;
	target?: HTMLAttributeAnchorTarget;
	locale?: string;
	className?: string;
	tabIndex?: number;
	children?: ReactNode;
}
export default GTMLink;
